module.exports = __webpack_public_path__ + "static/img/arrow_bk@3x.97b0341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/arrow_bk@3x.png
// module id = kGul
// module chunks = 10